import React from "react";
import Addon from "./Addon";

export default function AddonList({
  addons,
  foodItemQuantity,
  selectedAddons,
  onAddonQuantityChange,
  onAddonToggle,
  // onOptionToggle,
  onRadioOptionToggle,
  onCheckboxOptionToggle,
  onOptionQuantityChange,
  onSubOptionChange,
}) {
  return (
    <div className='addon-list'>
      {addons?.map((addon) => (
        <Addon
          key={addon.id}
          addon={addon}
          foodItemQuantity={foodItemQuantity}
          selectedAddon={selectedAddons[addon.id]}
          onAddonQuantityChange={onAddonQuantityChange}
          onAddonToggle={onAddonToggle}
          // onOptionToggle={onOptionToggle}
          onRadioOptionToggle={onRadioOptionToggle}
          onCheckboxOptionToggle={onCheckboxOptionToggle}
          onOptionQuantityChange={onOptionQuantityChange}
          onSubOptionChange={onSubOptionChange}
        />
      ))}
    </div>
  );
}
